<template>
    <span>
        <svg-icon :width="width" :height="height" :viewBox="`0 0 ${height} ${width}`" iconName="heart-fill">
            <defs>
                <path id="f5odhl0hla" d="M18.68 6.263h-.001zm.001.002l-.002-.003c-1.761-1.761-4.626-1.762-6.388-.001l-.001.001-.29.289-.288-.289C10.859 5.41 9.724 4.94 8.518 4.94c-1.207 0-2.342.47-3.195 1.323C4.47 7.115 4 8.25 4 9.457c0 1.206.47 2.34 1.323 3.194l6.22 6.22c.122.122.287.19.458.19.171 0 .336-.068.457-.19l6.22-6.22c1.761-1.76 1.763-4.625.003-6.386z"/>
            </defs>
            <g fill="none" fill-rule="evenodd">
                <mask id="r25p82pqeb" fill="#fff">
                    <use xlink:href="#f5odhl0hla"/>
                </mask>
                <g class="path" :fill="fill" mask="url(#r25p82pqeb)">
                    <path :d="`M0 0H${height}V${width}H0z`"/>
                </g>
            </g>
        </svg-icon>
    </span>
</template>

<script>
import SvgIcon from '@theme-views/common/SvgIcon'

export default {
    name: 'svg-heart-fill',
    computed: {
        fill() {
            return this.color || 'url(#linearGradient-1)'
        }
    },
    components: {
        SvgIcon
    },
    props: {
        width: {
            type: Number,
            default: 26,
        },
        height: {
            type: Number,
            default: 26,
        },
        color: {
            type: String,
            default: null
        }
    },
}
</script>